import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  recordedSubjectData: [],
  totalrecordedSubject: 0,
  isOpenModal: false,
}

export const recordedSubjectSlice = createSlice({
  name: "recordedSubject",
  initialState,
  reducers: {
    setrecordedSubjectData(state, { payload }) {
      state.recordedSubjectData = payload.result
      state.totalrecordedSubject = payload.count
    },
    updaterecordedSubjectData(state, { payload }) {
      const objIndex = state.recordedSubjectData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.recordedSubjectData[objIndex] = payload
      }
    },
    deleterecordedSubjectData(state, { payload }) {
      const objIndex = state.recordedSubjectData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.recordedSubjectData.splice(objIndex, 1)
        state.totalrecordedSubject -= 1
      }
    },
    pushrecordedSubjectData(state, { payload }) {
      state.recordedSubjectData.push(payload)
      state.totalrecordedSubject += 1
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
  }
})

export const { setrecordedSubjectData, updaterecordedSubjectData, deleterecordedSubjectData, pushrecordedSubjectData, isOpenModal,
  ModalToggle } = recordedSubjectSlice.actions;

export default recordedSubjectSlice.reducer;

export function getrecordedSubject(limit, offset,) {
  return async function getrecordedSubjectThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getrecordedSubject(limit, offset, ).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setrecordedSubjectData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addrecordedSubject(payload) {
  return async function addrecordedSubjectThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addrecordedSubject(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushrecordedSubjectData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updaterecordedSubject(id, title) {
  return async function updaterecordedSubjectThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updaterecordedSubject(id, title).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updaterecordedSubjectData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}


export function statusDeleterecordedSubject(payload) {
  return async function statuseleterecordedSubjectThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.deleteRecordedSubject(payload.id, payload.status).then(
        (response) => {
          dispatch(deleterecordedSubjectData(payload.id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}



